import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';

var _excluded = ["value", "forwardedRef", "children"];
var Option = function Option(_ref) {
  var value = _ref.value,
    forwardedRef = _ref.forwardedRef,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("option", _extends({
    ref: forwardedRef,
    value: value,
    key: value
  }, rest), children);
};

export { Option };
